import { useIntl } from '@weenat/wintl';
import moment from 'moment-timezone';
import { useRef } from 'react';
import { useClient } from '../../../ClientProvider';
import schemas from '../../../schemas';
import useQuery from '../../../useQuery';
import useOrderedFields from '../../useOrderedFields';
import { decitraitResourceToOptions } from './utils';
/** This is the same schema as for the creation and update */
const schema = schemas.decitrait.createPlot;
const useDecitraitCreateOrUpdatePlot = ({ plot, defaultValues, mutate, request }) => {
    const { t } = useIntl();
    const formRef = useRef();
    const client = useClient();
    const resourcesRequest = useQuery(client.decitrait.getResources({ organizationId: plot.organizationId }));
    const resources = resourcesRequest.data;
    const { isPending, isError, isSuccess } = request;
    const fieldProps = useOrderedFields([
        'name',
        'plotArea',
        'harvestDate',
        'trainingMethod',
        'interPlant',
        'interRow',
        'mildewSensibility',
        'oidiumSensibility',
        'hadOidiumAttack'
    ], formRef, {
        shared: { isDisabled: isPending },
        labelSource: 'dss.decitrait.inputs'
    });
    if (!resources)
        return null;
    const handleSubmit = ({ hadOidiumAttack, harvestDate, ...values }) => {
        mutate({
            harvestDate: moment(harvestDate).format('DD/MM'),
            hadOidiumAttack: resources.yesNo[hadOidiumAttack ? 0 : 1]?.id,
            ...values
        });
    };
    const createPlotDefaultValues = {
        name: plot.name,
        harvestDate: new Date(2020, 8, 20),
        plotArea: 0.8,
        mildewSensibility: resources.sensibility[1]?.id,
        oidiumSensibility: resources.sensibility[1]?.id,
        trainingMethod: resources.sensibility[1]?.id,
        interPlant: 0.75,
        interRow: 1
    };
    const initialValues = {
        ...createPlotDefaultValues,
        /** Update default values override creation ones */
        ...(defaultValues || {})
    };
    const props = {
        field: {
            ...fieldProps,
            trainingMethod: {
                ...fieldProps.trainingMethod,
                options: decitraitResourceToOptions(resources.trainingMethod)
            },
            mildewSensibility: {
                ...fieldProps.mildewSensibility,
                options: decitraitResourceToOptions(resources.sensibility)
            },
            oidiumSensibility: {
                ...fieldProps.oidiumSensibility,
                options: decitraitResourceToOptions(resources.sensibility)
            }
        },
        form: {
            schema,
            initialValues,
            onSubmit: handleSubmit,
            formRef
        },
        submitButton: {
            topPadded: true,
            isDisabled: isPending,
            isError,
            isSuccess,
            children: t('actions.confirm')
        }
    };
    return { props };
};
export default useDecitraitCreateOrUpdatePlot;
